import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import CreateOrderForm from '../../../modules/orders/components/CreateOrderForm';

const CreateOrder = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_order') : t('create_order');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/orders/create-order' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateOrderForm />
    </div>
  );
};

export default CreateOrder;
